const DataTableColumn = require('./DataTableColumn');

module.exports = DataTableColumn;
